/**
 * 这个文件放置所有路由和常用地址
 */
export const SMART_RECEPTION_PATH =
  '/p/wedding/Public/admin/merchant_message/dist/index.html#/chat/settings/reception' // 预设问题

export const ACTIVITY_DIY_PATH = '/localMerchant/registrationActivity'
export const ACTIVITY_DIY_PATH_A = `#${ACTIVITY_DIY_PATH}` // 活动 diy

// 婚礼现场
export const WEDDING_SITE_PATH = 'localMerchant/marketingCenter/wedding-site'

export const LITE_APP_SELECT_PATH =
  '/localMerchant/marketingCenter/selectVersion' // 小程序
export const LITE_APP_SELECT_PATH_A =
  '#/localMerchant/marketingCenter/selectVersion'
export const LITE_APP_PATH = '/localMerchant/liteApp' // 小程序页面
export const LITE_APP_PATH_A = '#/localMerchant/liteApp' // 小程序页面
export const LITE_APP_MANAGE_PATH = '/localMerchant/liteApp/manage' // 小程序管理页面
export const LITE_APP_MANAGE_PATH_A = '#/localMerchant/liteApp/manage'

export const REACT_ANTD_PATH =
  '//admin.hunliji.com/p/admin/Tpl/Home/default/richTextThread/dist/index.html'

export const WATER_STORE_PATH =
  '/p/wedding/Public/web/activity/storeMarketDownLoad.html' // 水镜

export const CHOOSE_CASE_PROPERTY_PATH =
  '/localMerchant/case/publish/chooseProperty'

export const PUBLISH_MEAL_PATH = '/localMerchant/setMeal/create' // 发布套餐页面
export const PUBLISH_MEAL_PATH_A = `#${PUBLISH_MEAL_PATH}`

export const PUBLISH_MEAL_REVIEW_PATH = '/localMerchant/setMeal/review' // 发布套餐审核页面
export const PUBLISH_MEAL_REVIEW_PATH_A = `#${PUBLISH_MEAL_REVIEW_PATH}`

// 加盟店发布套餐页面
export const STORE_PUBLISH_MEAL_PATH = PUBLISH_MEAL_PATH // 发布套餐页面
export const STORE_PUBLISH_MEAL_PATH_A = `#${STORE_PUBLISH_MEAL_PATH}`

export const PUBLISH_SING_PRODUCT_PATH = '/localMerchant/singleProduct/create' //发布单品
export const PUBLISH_SING_PRODUCT_PATH_A = `#${PUBLISH_SING_PRODUCT_PATH}`

export const PUBLISH_CASE_PATH = '/localMerchant/case/add' // 案例发布页面
export const PUBLISH_CASE_PATH_A = `#${PUBLISH_CASE_PATH}`

export const PUBLISH_STYLE_PATH = '/localMerchant/addressStyle/add' // 款式发布页面
export const PUBLISH_STYLE_PATH_A = `#${PUBLISH_STYLE_PATH}`

export const PUBLISH_CASE_AUDIT_PATH = '/localMerchant/case/auditList' // 案例发布审核页面
export const PUBLISH_CASE_AUDIT_PATH_A = `#${PUBLISH_CASE_AUDIT_PATH}`

export const DYNAMIC_PATH = '/localMerchant/dynamic' // 动态管理
export const DYNAMIC_PATH_A = `#${DYNAMIC_PATH}`

export const EDIT_CASE_PATH = '/localMerchant/case/detail' // 编辑案例 /localMerchant/storeCase/detail/755528?propertyId=6
export const EDIT_CASE_PATH_A = `#${EDIT_CASE_PATH}`

export const EDIT_STORE_CASE_PATH = '/shuijingCase/detail' // 编辑门店案例页面 #/localMerchant/storeCase/detail/792012?propertyId=6
export const EDIT_STORE_CASE_PATH_A = `#${EDIT_STORE_CASE_PATH}`

export const STORE_PARTNER_PATH =
  '/p/wedding/Public/web/StorePartner/index.html'

/**
 * 路由地址
 */
export const HOME_PATH = '/localMerchant/home'
export const HOME_PATH_A = `#${HOME_PATH}`

export const FLAGSHIP_PUBLICIZE_PATH =
  '/localMerchant/marketingCenter/flagshipPublicize'
export const FLAGSHIP_PUBLICIZE_PATH_A = `#${FLAGSHIP_PUBLICIZE_PATH}`

export const CUSTOMER_MANAGE_LIST_PATH = '/localMerchant/customerManage' // 客资
export const CUSTOMER_MANAGE_LIST_PATH_A = `#${CUSTOMER_MANAGE_LIST_PATH}`
export const CUSTOMER_MANAGE_EDIT_PATH = `${CUSTOMER_MANAGE_LIST_PATH}/edit`
export const RECOMMEND_CUSTOMER_PATH = '/localMerchant/customerInfo'
export const EXPERIENCE_SHOP_RECOMMEND_PATH = '/localMerchant/experienceShop'

export const COOPERATION_PATH = '/localMerchant/experienceShopManage'

export const ORDER_PATH = '/localMerchant/orderManage_new'
export const ORDER_PATH_A = `#${ORDER_PATH}`

export const INCOME_PATH = '/localMerchant/incomeManage'
export const INCOME_PATH_A = `#${INCOME_PATH}`

export const EXPERIENCE_SHOP_COOP_MANAGE = '/localMerchant/experienceShopManage'
export const EXPERIENCE_SHOP_COOP_MANAGE_A = `#${EXPERIENCE_SHOP_COOP_MANAGE}`

export const EXPERIENCE_SHOP_BILL_PATH =
  '/localMerchant/experienceShopManage/checkBill'
export const EXPERIENCE_SHOP_BILL_PATH_A = `#${EXPERIENCE_SHOP_BILL_PATH}`

export const MATERIAL_PATH = '/localMerchant/creativeCenter'
export const MATERIAL_PATH_A = `#${MATERIAL_PATH}`

export const MATERIAL_PATH_ADD = MATERIAL_PATH + '/add'
export const MATERIAL_PATH_ADD_A = MATERIAL_PATH_A + '/add'

export const ACCOUNT_SERVICE_PATH = '/localMerchant/serviceAccount'
export const ACCOUNT_SERVICE_PATH_A = `#${ACCOUNT_SERVICE_PATH}`

export const MARKETING_CENTER_PATH = '/localMerchant/marketingCenter/market'
export const MARKETING_CENTER_PATH_A = `#${MARKETING_CENTER_PATH}`

export const LIVE_MANAGE_PATH = '/localMerchant/liveManage'
export const LIVE_MANAGE_PATH_A = `#${LIVE_MANAGE_PATH}`

export const SETMEAL_PATH = '/localMerchant/setMeal' // 套餐管理
export const SETMEAL_PATH_A = `#${SETMEAL_PATH}`

export const WATER_MIRROR_SETTING_PATH =
  '/p/wedding/Public/admin/desktop_app_set/dist/index.html#/login'
export const WATER_MIRROR_ORDER_PATH =
  '/p/wedding/Public/admin/hlj-shuijing-merchant/dist/index.html#/login'
export const SETTING_PATH = '/localMerchant/setting'
export const SETTING_PATH_A = `#${SETTING_PATH}`

export const ACCOUNT_MANAGE_PATH = '/localMerchant/accountManage'
export const ACCOUNT_MANAGE_PATH_A = `#${ACCOUNT_MANAGE_PATH}`

export const SETTLEMENTACCOUNT_MANAGE_PATH = '/localMerchant/settlementAccount'
export const SETTLEMENTACCOUNT_MANAGE_PATH_A = `#${SETTLEMENTACCOUNT_MANAGE_PATH}`

export const SETTLEMENTACCOUNT_UPDATE_PATH = `${SETTLEMENTACCOUNT_MANAGE_PATH}/editAccount`
export const SETTLEMENTACCOUNT_UPDATE_PATH_A = `#${SETTLEMENTACCOUNT_UPDATE_PATH}`

export const MARKETING_PRODUCT_DETAIL_PATH =
  '/localMerchant/marketingCenter/detail'
export const MARKETING_PRODUCT_DETAIL_PATH_A = `#${MARKETING_PRODUCT_DETAIL_PATH}`

// 购买记录
export const PURCHASE_HISTORY_PATH = '/localMerchant/purchaseHistory'
export const PURCHASE_HISTORY_PATH_A = `#${PURCHASE_HISTORY_PATH}`

// 天眼系统
export const SKY_EYE_SYSTEM_PATH = '/localMerchant/skyEyeSystem'
export const SKY_EYE_SYSTEM_PATH_A = `#${SKY_EYE_SYSTEM_PATH}`

export const BOND_PATH = `${MARKETING_PRODUCT_DETAIL_PATH}/gurantee`
export const BOND_PATH_A = `#${BOND_PATH}`

export const MY_SHOP_PATH = `/localMerchant/myShop`
export const MY_SHOP_PATH_A = `#${MY_SHOP_PATH}`

export const REALNAME_AUTH_PATH = '/localMerchant/realnameAuthentication'
export const REALNAME_AUTH_PATH_A = `#${REALNAME_AUTH_PATH}`

export const STUFF_ACCOUNT_MANAGE_PATH = '/localMerchant/serviceAccount' // 私信客服管理
export const STUFF_ACCOUNT_MANAGE_PATH_A = `#${STUFF_ACCOUNT_MANAGE_PATH}`
export const JIAMENG_GOODS_PATH = '/localMerchant/jiaMengGoods'
export const JIAMENG_GOODS_PATH_A = `#${JIAMENG_GOODS_PATH}`

export const WEDDING_PHOTO_PUBLISH_PATH =
  '/localMerchant/jiaMengGoods/weddingPhotoMeal'

export const CHOOSE_WEDDING_PHOTO_PATH_COMMON =
  '/localMerchant/setMeal/publish/weddingPhotoMeal?propertyId=6' // 选择婚纱摄影类型-普通商家

export const CHOOSE_WEDDING_PHOTO_PATH =
  WEDDING_PHOTO_PUBLISH_PATH + '?propertyId=6' // 选择婚纱摄影类型-加盟商家

export const CHOOSE_MEAL_PROPERTY_PATH =
  '/localMerchant/jiaMengGoods/chooseProperty'

export const HUN_PIN_GOODS_MANAGE_PATH =
  '/localMerchant/jiaMengGoods/weddingSupervise'
export const HUN_PIN_GOODS_MANAGE_PATH_A = `#${HUN_PIN_GOODS_MANAGE_PATH}`

export const JIA_MENG_GOODS_MANAGE_PATH =
  '/localMerchant/jiaMengGoods/weddingPhoto'
export const JIA_MENG_GOODS_MANAGE_PATH_A = `#${JIA_MENG_GOODS_MANAGE_PATH}`

export const DECORATION_PATH = '/localMerchant/decoration'
export const DECORATION_PATH_A = `#${DECORATION_PATH}`

export const APPRAISE_LIST_PATH = '/localMerchant/appraise' // 评价管理
export const APPRAISE_LIST_PATH_A = `#${APPRAISE_LIST_PATH}`

export const EDIT_STORE_PATH = '/localMerchant/editStore'
export const EDIT_STORE_PATH_A = `#${EDIT_STORE_PATH}`

export const JUKE_PATH = '/localMerchant/jukeTreasure'
export const JUKE_PATH_A = `#${JUKE_PATH}`

export const COUPONS_PATH = '/localMerchant/coupons'
export const COUPONS_PATH_A = `#${COUPONS_PATH}`

export const CASE_MANAGE_PATH = '/localMerchant/case'
export const CASE_MANAGE_PATH_A = `#${CASE_MANAGE_PATH}`

export const VR_MANAGE_PATH = '/localMerchant/vr'
export const VR_SELL_PATH = '/localMerchant/vr/sell'
export const VR_SELL_PATH_A = `#${VR_SELL_PATH}`

export const VR_INFO_PATH = '/localMerchant/vr/manage/info'
export const VR_INFO_PATH_A = `#${VR_INFO_PATH}`

export const SINGLE_PRODUCT_PATH = '/localMerchant/singleProduct'
export const SINGLE_PRODUCT_PATH_A = `#${SINGLE_PRODUCT_PATH}`

export const SINGLE_PRODUCT_DRAFT_BOX = SINGLE_PRODUCT_PATH + '/draftBox'
export const SINGLE_PRODUCT_DRAFT_BOX_A = SINGLE_PRODUCT_PATH_A + '/draftBox'

export const SINGLE_PRODUCT_REVIEW = SINGLE_PRODUCT_PATH + '/review'
export const SINGLE_PRODUCT_REVIEW_A = SINGLE_PRODUCT_PATH_A + '/review'

export const GUARANTEE_PATH = '/localMerchant/bond'
export const GUARANTEE_PATH_A = '#/localMerchant/bond'

export const ZHI_TUI_BAO_PATH = '/localMerchant/zhiTuiBao'
export const MULTI_STORE_MANAGE_PATH = '/localMerchant/multiStore'

export const JIAMENG_SCHEDULE = '/localMerchant/schedule' // 加盟店日程
export const JIAMENG_CUSTOMER_PATH = '/localMerchant/newCustomer' // 加盟店客户
export const JIAMENG_CUSTOMER_DETAIL_PATH = '/localMerchant/newCustomer/detail' // 加盟店客户详情
export const JIAMENG_CUSTOMER_DETAIL_PATH_A = `#${JIAMENG_CUSTOMER_DETAIL_PATH}`
export const JIAMENG_STATS_PATH = '/localMerchant/stats' // 加盟店数据

export const SHOP_DATA_PATH = '/localMerchant/shopData'
export const SHOP_DATA_PATH_A = '#/localMerchant/shopData'
export const CONTENT_DATA_PATH = '/localMerchant/contentData'
export const DECORATION_ANALYSIS_PATH = '/localMerchant/decorationAnalysis'

export const SHOP_PRODUCTS_PATH = '/localMerchant/marketingCenter/shopProduct' // 店铺产品宣传页
export const SHOP_PRODUCTS_PATH_A = `#${SHOP_PRODUCTS_PATH}` // 店铺产品宣传页

export const DATA_MARKETING_PATH = '/localMerchant/DataMarketingPage' // 数据中心宣传页
export const DATA_MARKETING_PATH_A = `#${DATA_MARKETING_PATH}` // 数据中心宣传页

export const SUCCESSFULLY_OPENED_PATH =
  '/localMerchant/marketingCenter/successfullyOpened' // 购买成功结果页
export const SUCCESSFULLY_OPENED_PATH_A = `#${SUCCESSFULLY_OPENED_PATH}` // 购买成功结果页

export const SHOP_PRODUCTS_ACTIVATECODE_PATH =
  '/localMerchant/marketingCenter/shopProduct/activateCode' // 使用激活码页面
export const SHOP_PRODUCTS_ACTIVATECODE_PATH_A = `#${SHOP_PRODUCTS_ACTIVATECODE_PATH}` // 使用激活码页面

export const SHOP_NOTICE_PATH = '/localMerchant/notice' // 店铺公告
export const SHOP_NOTICE_PATH_A = `#${SHOP_NOTICE_PATH}` // 店铺公告

export const TASK_CENTER_PATH = '/localMerchant/taskCenter' // 任务中心
export const TASK_CENTER_PATH_A = `#${TASK_CENTER_PATH}`

export const CERTIFICATION_PATH = '/localMerchant/certification' // 品牌认证

export const BRAND_PATH = '/localMerchant/brand' // 品牌认证

export const NAME_CARD_MANAGE_PATH = '/localMerchant/nameCardManage'
export const NAME_CARD_MANAGE_PATH_A = `#${NAME_CARD_MANAGE_PATH}`
export const CARD_ATLAS_MANAGE_PATH = '/localMerchant/atlasManage'
export const CARD_ATLAS_DETAIL_PATH = '/localMerchant/atlasManage/detail'

export const MEAL_MANAGE_PATH = '/localMerchant/setMeal'
export const MEAL_MANAGE_PATH_A = `#${MEAL_MANAGE_PATH}`

export const SERIAL_MANAGE = MEAL_MANAGE_PATH + '/serialManage' // 套餐管理-系列管理
export const SERIAL_MANAGE_A = MEAL_MANAGE_PATH_A + '/serialManage'

export const SET_MEAL_REVIEW = MEAL_MANAGE_PATH + '/review' // 套餐管理-审核
export const SET_MEAL_REVIEW_A = MEAL_MANAGE_PATH_A + '/review'

export const SET_MEAL_DRAFT_BOX = MEAL_MANAGE_PATH + '/draftBox' // 套餐管理-草稿箱
export const SET_MEAL_DRAFT_BOX_A = MEAL_MANAGE_PATH_A + '/draftBox'

export const SET_MEAL_ORDER = MEAL_MANAGE_PATH + '/order' // 套餐管理-排序
export const SET_MEAL_ORDER_A = MEAL_MANAGE_PATH_A + '/order'

export const MY_COUPON_PATH = '/localMerchant/myCoupon' // 我的卡券
export const MY_COUPON_PATH_A = `#${MY_COUPON_PATH}`

export const GROUP_SETTING_PATH = '/localMerchant/groupSetting' // 团队设置
export const GROUP_SETTING_PATH_A = `#${GROUP_SETTING_PATH}` // 团队设置

export const GROUP_MEMBER_PATH = '/localMerchant/groupMember' // 团队成员
export const GROUP_MEMBER_PATH_A = `#${GROUP_MEMBER_PATH}` // 团队成员

export const SCHEDULETOOL_PATH = '/localMerchant/scheduleTool' // 档期
export const SCHEDULETOOL_PATH_A = `#${SCHEDULETOOL_PATH}` // 档期

export const WEI_SHOP_PATH = '/localMerchant/weiShopSetting' // 微官网
export const WEI_SHOP_PATH_A = `#${WEI_SHOP_PATH}` // 微官网

export const ZGT_PATH = '/localMerchant/zhiGuangTong'
export const ZGT_PATH_A = `#${ZGT_PATH}`

export const SI_YI_TEAM_GROUP_MEMBER_PATH = '/localMerchant/siYiTeamGroupMember' // 司仪团队成员
export const SI_YI_TEAM_GROUP_MEMBER_PATH_A = `#${SI_YI_TEAM_GROUP_MEMBER_PATH}`

export const STAFF_MANAGE_PATH = '/localMerchant/staff'
export const STAFF_MANAGE_PATH_A = `#${STAFF_MANAGE_PATH}`

export const SKY_EYE_PATH = `/localMerchant/SkyEyeSystem/introduce`
export const SKY_EYE_PATH_A = `#${SKY_EYE_PATH}`

export const NOTIFICATION_MANAGE_PATH = '/localMerchant/notificationManage'
export const NOTIFICATION_MANAGE_PATH_A = `#${NOTIFICATION_MANAGE_PATH}`

export const TASK_PATH_MAPPING = {
  '1': DECORATION_PATH_A + '?type=background',
  '2': PUBLISH_MEAL_PATH_A,
  '3': PUBLISH_CASE_PATH_A,
  '4': DYNAMIC_PATH_A,
  '5': DECORATION_PATH_A + '?type=notice',
  '8': PUBLISH_MEAL_PATH_A,
  '9': PUBLISH_CASE_PATH_A,
  '10': DYNAMIC_PATH_A,
  '11': DECORATION_PATH_A + '?type=notice',
  '12': PUBLISH_MEAL_PATH_A,
  '13': PUBLISH_CASE_PATH_A,
  '14': DYNAMIC_PATH_A,
  '15': SHOP_NOTICE_PATH_A
}

export const SITEMANAGE_PATH = '/localMerchant/siteManage' // 场地管理路径

export const CONTENT_CENTER_PATH = '/localMerchant/contentCenter' // 内容中心

export const CONTENT_CENTER_CREATION_PATH = '/localMerchant/creation' // 我的创作
export const CONTENT_CENTER_CREATION_PATH_A = '#/localMerchant/creation' // 我的创作

export const DELIVER_MOUDLE_PATH =
  '/localMerchant/marketingCenter/DeliverModule' // 交付系统
export const DELIVER_MOUDLE_PATH_A = `#${DELIVER_MOUDLE_PATH}` // 交付系统

// 酒店信息路径
export const EXCLUSIVEOFFERS_PATH = '/localMerchant/exclusiveOffers' // 专享优惠

export const SELLERSERVICE_PATH = '/localMerchant/sellerService' // 商家服务号
export const SELLERSERVICE_PATH_A = `#${SELLERSERVICE_PATH}` // 商家服务号
export const SETTLEMENTACCOUNT_PATH = '/localMerchant/settlementAccount' // 结算账户
export const ALBUM_MANAGE_PATH = '/localMerchant/albumManage'
export const ALBUM_MANAGE_PATH_A = `#${ALBUM_MANAGE_PATH}`

// 签署协议成功页面
export const CONTRACT_SIGN_SUCCESS = '/localMerchant/contract/success'
export const CONTRACT_SIGN_SUCCESS_A = `#${CONTRACT_SIGN_SUCCESS}`

// 婚礼纪商家中心登录页
export const SHOP_LOGIN_PATH =
  '/p/frontend/merchant-center/dist/index.html#/login'

// 婚礼纪商家工作台
// eslint-disable-next-line
export const HLJ_MERCHANT_CENTER = `${__MERCHANT_CENTER_PATH__}#/workbench`

// 婚礼纪商家中心我的账号
// eslint-disable-next-line
export const HLJ_MERCHANT_CENTER_REDIRECT_PATH = `${__MERCHANT_CENTER_PATH__}#/redirect/login`

// 婚礼纪商家中心我的账号
export const HLJ_MERCHANT_MY_COUNT =
  HLJ_MERCHANT_CENTER_REDIRECT_PATH + '?type=0&centerPath=2&from=1&jti='

// 婚礼纪商家中心店铺管理
export const HLJ_MERCHANT_STORE_MANAGE =
  HLJ_MERCHANT_CENTER_REDIRECT_PATH + '?type=0&centerPath=3&jti='

// 婚礼纪商家中心员工管理
export const HLJ_MERCHANT_STAFF_MANAGE =
  HLJ_MERCHANT_CENTER_REDIRECT_PATH + '?type=0&centerPath=4&jti='

// 婚礼纪商家中心工作台
export const HLJ_MERCHANT_WORK_PLATFORM =
  HLJ_MERCHANT_CENTER_REDIRECT_PATH + '?type=0&centerPath=0&jti='

export const siyiStatus =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/siyiStatus'
export const sidaPersonal =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/sidaPersonal'
export const freeShopEditStore =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/editStore'
export const freeShop = '/p/frontend/merchant-center/dist/index.html#/freeShop'
export const chooseProperty =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/chooseProperty'
export const chooseType =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/chooseType'
export const sidaGroup =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/sidaGroup'
export const register =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/register'
export const onLineShopMarket =
  '/p/frontend/merchant-center/dist/index.html#/onlineStoreMarket'
export const CENTER_REAL_NAME =
  '/p/frontend/merchant-center/dist/index.html#/freeShop/realnameAuthentication'

// 犀牛学院详情页
export const RHINOCEROS_ACADEMY = '/localMerchant/rhinocerosAcademy'
export const RHINOCEROS_ACADEMY_A = `#${RHINOCEROS_ACADEMY}`

// 盘古页面(目前不同端口携带前缀，后续去除前缀)
// eslint-disable-next-line
export const PANGU_HOME = `${__PHP_DOMAIN__}/panGu/app?jti=`
